import _ from 'lodash'

import {isPresent} from '../../../../../common/utils.js'
import api from '../../../../../common/api.js'
import baseStrategy from './baseStrategy.js'

import {setColumnsToDataMap} from '../../dataImport/index.js'

export const SAMPLE_ADDRESSES = [
  {
    name: '',
    company: 'Liberty State Park',
    phone: '',
    fax: '',
    email: '',
    street1: '450 Freedom Way',
    street2: '',
    city: 'Jersey City',
    state: 'NJ',
    zip: '07305',
    country: 'US',
    reference_number: '',
  },
  {
    name: 'Sid Grauman',
    company: 'Grauman’s Chinese Theatre',
    phone: '1 (323) 461-3331',
    fax: '1 (323) 463-0879',
    email: 'manager@chinesetheatres.com',
    street1: '6925 Hollywood Boulevard',
    street2: 'c/o Mary Pickford',
    city: 'Hollywood',
    state: 'CA',
    zip: '90028',
    country: 'US',
    reference_number: '1234567890',
  },
  {
    name: 'Mr. Rogers',
    company: '',
    phone: '',
    fax: '',
    email: '',
    street1: '5381 Northumberland St',
    street2: '',
    city: 'Pittsburgh',
    state: 'PA',
    zip: '15217',
    country: 'US',
    reference_number: '',
  },
  {
    name: '',
    company: 'Niagara Power Plant',
    phone: '',
    fax: '',
    email: '',
    street1: '7005 Niagara River Pkwy',
    street2: '',
    city: 'Niagara Falls',
    state: 'ON',
    zip: 'L0S 1A0',
    country: 'CA',
    reference_number: '',
  },
  {
    name: 'Frodo Baggins',
    company: 'Hobbiton',
    phone: '64 (7) 888 1505',
    fax: '',
    email: '',
    street1: '501 Buckland Road',
    street2: 'Hinuera',
    city: 'Matamata',
    state: '',
    zip: '3472',
    country: 'NZ',
    reference_number: '',
  },
]

export default class addressStrategy extends baseStrategy {
  static title = 'Create Addresses'

  static getExampleRows() {
    return () => {
      const rows = [
        [
          'Name',
          'Company',
          'Phone',
          'Fax',
          'Email',
          'Street1',
          'Street2',
          'City',
          'State',
          'Zip',
          'Country',
          'Reference Number',
        ],
      ]

      SAMPLE_ADDRESSES.forEach((address) => {
        rows.push([
          address.name,
          address.company,
          address.phone,
          address.fax,
          address.email,
          address.street1,
          address.street2,
          address.city,
          address.state,
          address.zip,
          address.country,
          address.reference_number,
        ])
      })

      return Promise.resolve(rows)
    }
  }

  static transformRowToData(row, columnsByName) {
    const data = this.getNewData()

    data.payload = {
      name: row[columnsByName.name],
      company: row[columnsByName.company],
      phone: row[columnsByName.phone],
      fax: row[columnsByName.fax],
      email: row[columnsByName.email],
      street1: row[columnsByName.street1],
      street2: row[columnsByName.street2],
      city: row[columnsByName.city],
      state: row[columnsByName.state],
      zip: row[columnsByName.zip],
      country: row[columnsByName.country],
      reference_number: row[columnsByName.reference_number],
    }

    data.errors = this.determineDataErrors(data)

    return data
  }

  static guessAtColumnDataMap(columns) {
    function find(regex) {
      return columns.findIndex((column) => column.search(regex) !== -1)
    }

    const columnsToDataMap = {
      name: find(/name/i),
      company: find(/company/i),
      phone: find(/phone/i),
      fax: find(/fax/i),
      email: find(/email/i),
      street1: find(/street1/i),
      street2: find(/street2/i),
      city: find(/city/i),
      state: find(/state/i),
      zip: find(/zip/i),
      country: find(/country/i),
      reference_number: find(/reference.number/i),
    }

    return setColumnsToDataMap(columnsToDataMap)
  }

  static determineDataErrors(data) {
    const payload = data.payload
    const errors = {...data.errors}

    if (_.every(payload, (value) => !isPresent(value))) {
      errors.payload = 'Address can not be completely empty'
    } else {
      delete errors.payload
    }

    return errors
  }

  static save(data) {
    return () => api.post('/address', data.payload)
  }
}
